import React, { useState, useEffect } from "react";
import styles from "../css/Profile.module.css";
import Layout from "./Layout";
import Drawer from "./Drawer";
import {
  baseUrl,
  fetchAirtimeHistory,
  getUserPoints,
  totalPointsAPI,
  userNumberApi
} from "../api/api";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import UserMatchesPage from "../pages/UserMatchesPage";
import UserMatchesPageProfile from "../pages/UserMatchesPageProfile ";

const Profile = () => {
  const [loading, setLoading] = useState(false);
  const [points, setPoints] = useState(0);
  const { user } = useSelector((state) => state.userSlice);
  const [userNumber, setUserNumber] = useState("");
  const [airtimeData, setAirtimeData] = useState([]);



  console.log(user,'userp-----------------------------')

  const navigate = useNavigate();

  useEffect(() => {
    fetchDataFromPoints();
    // numberFetch();
    // fetchAirtimeData(); // Load airtime history directly
  }, []);

  const fetchDataFromPoints = async () => {
  try {
    setLoading(true);
    const response = await axios.post(
      `${baseUrl}${getUserPoints}`,
      { userId: user?.id },
      // {
      //   headers: {
      //     Authorization: `Bearer ${user?.token}`,
      //   },
      // }
    );
    console.log(response, "---api res---");
    setUserNumber(response?.data?.[0]?.user_number || 0)
    setPoints(response?.data?.[0]?.total_user_points || 0);
  } catch (error) {
    toast.error(
      error?.response?.data?.[0]?.message ||
      error?.data?.message ||
      error?.message ||
      "Something went wrong"
    );
  } finally {
    setLoading(false);
  }
};


  return (
    <Layout active={15}>
      <Drawer active={15} />
      <div className={styles.container}>
        <div className={styles.verticalLayout}>
          <div className={styles.mainProfile}>
 <div className={styles.profileCard}>
            <div className={styles.avatarSection}>
              <img
                src="/assets/images/user2.png"
                alt="user-avatar"
                className={styles.avatar}
              />
              <h2 className={styles.name}>{user?.user_name}</h2>
              <hr className={styles.separator} />
            </div>

            <div className={styles.cardInfo}>
              <div className={styles.tierSection}>
                <span className={styles.tierLabel}>Your Points</span>
                <span className={styles.points}>
                  <img
                    src="/assets/images/medal.png"
                    alt="points-icon"
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "5px",
                      verticalAlign: "middle",
                    }}
                  />
                  {points}
                </span>
              </div>

              <div className={styles.infoItem}>
                <label>User Number:</label>
                <span className={styles.value}>{user?.user_number.toUpperCase()}</span>
              </div>

              <hr className={styles.separator} />

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                {/* <div
                  onClick={() => navigate("/terms&condition")}
                  className={styles.termsLink}
                  style={{ cursor: "pointer" }}
                >
                  View Terms & Conditions
                </div> */}
              </div>
            </div>
          </div>
          </div>
         

          {/* Airtime History Table */}
          {/* <div className={styles.airtimeHistorySection}>
            <h3 className={styles.airtimeTitle}>Airtime History</h3>
            {airtimeData.length === 0 ? (
              <p className={styles.textheading}>No data available.</p>
            ) : (
              <div className={styles.airtimeTableWrapper}>
                <table className={styles.table}>
                  <thead>
                    <tr>
                      <th>User Number</th>
                      <th>Send Date</th>
                      <th>Rank</th>
                      <th>Price Sent</th>
                    </tr>
                  </thead>
                  <tbody>
                    {airtimeData.map((item, index) => (
                      <tr key={index}>
                        <td>{item.user_number}</td>
                        <td>{item.send_date?.split("T")[0]}</td>
                        <td>{item.user_rank}</td>
                        <td>{item.price_send}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div> */}

          <UserMatchesPageProfile/>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;